import { useFetch, createError } from "nuxt/app";
import { computed, unref } from "vue";
import { defu } from "defu";
export const usePage = (request, options) => {
  const _request = computed(() => {
    let r = request;
    if (typeof r === "function") {
      r = r();
    }
    return unref(r);
  });
  const defaults = {
    key: typeof _request.value === "string" ? _request.value : crypto.randomUUID(),
    onResponseError(ctx) {
      if (ctx.error) {
        throw createError(ctx.error);
      }
    }
  };
  const params = defu(options, defaults);
  return useFetch(request, params);
};
